var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "tile is-parent" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "fixed-grid has-12-cols" },
              [
                _c("div", { staticClass: "grid is-col-min-15" }, [
                  _c("div", { staticClass: "cell is-col-span-6 left-column" }, [
                    _c(
                      "article",
                      {
                        staticClass:
                          "box detail-page-tile is-flex-grow-1 is-flex is-flex-direction-column pt-2",
                        staticStyle: { "max-height": "calc(120vh - 8rem)" },
                      },
                      [
                        _c("div", { staticClass: "tabs mb-4" }, [
                          _c("ul", [
                            _c(
                              "li",
                              {
                                staticClass: "sub-title",
                                class: {
                                  "is-active": _vm.selectedTab === "current",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.selectedTab = "current"
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("System Messages")])]
                                ),
                              ]
                            ),
                            _c(
                              "li",
                              {
                                staticClass: "sub-title",
                                class: {
                                  "is-active": _vm.selectedTab === "archived",
                                },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.selectedTab = "archived"
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("Archived Messages")])]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm.isLoading
                          ? _c(
                              "div",
                              { staticClass: "has-text-centered p-4" },
                              [
                                _vm._m(0),
                                _c("p", { staticClass: "mt-2" }, [
                                  _vm._v("Loading messages..."),
                                ]),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                ref: "messagesContainer",
                                staticClass:
                                  "is-flex-grow-1 is-overflow-y-auto pt-4 pr-4",
                                staticStyle: { "max-height": "calc(120vh)" },
                                on: { scroll: _vm.onScroll },
                              },
                              [
                                _vm.filteredMessages.length === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-text-centered p-4 has-text-grey",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "msr msr-36px has-text-grey",
                                          },
                                          [_vm._v(" add_comment ")]
                                        ),
                                        _c("p", { staticClass: "mt-2" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.selectedTab === "current"
                                                  ? "No system-wide messages are currently published."
                                                  : "No archived messages."
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _vm.selectedTab === "current"
                                          ? _c("p", { staticClass: "mt-2" }, [
                                              _vm._v(
                                                " Add a new message to keep users informed of any issues or announcements. "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._l(
                                  _vm.filteredMessages,
                                  function (message) {
                                    return _c(
                                      "div",
                                      {
                                        key: message.systemMessageId,
                                        staticClass: "message-card mb-6",
                                        staticStyle: { position: "relative" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "is-size-7 has-text-grey",
                                            staticStyle: {
                                              position: "absolute",
                                              top: "-1.2rem",
                                              left: "0",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  message.modifiedByName ||
                                                    message.createdByName
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.$filters.formatDateTimeLocale(
                                                    message.modifiedDate ||
                                                      message.createdDate,
                                                    _vm.$userInfo.locale
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "is-flex is-justify-content-space-between is-align-items-start mb-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center",
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "message-indicator mr-2",
                                                  class:
                                                    _vm.getMessageTypeClass(
                                                      message.type
                                                    ),
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "message-title has-text-weight-semibold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(message.title) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center",
                                              },
                                              [
                                                message.isDraft
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tag is-rounded mr-2",
                                                      },
                                                      [_vm._v(" Draft ")]
                                                    )
                                                  : message.active
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tag is-success mr-2 has-text-light",
                                                      },
                                                      [
                                                        _vm._m(1, true),
                                                        _vm._v("  Active "),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._m(2, true),
                                                    ]),
                                                !message.isDraft &&
                                                _vm.selectedTab === "current"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pretty p-switch p-fill",
                                                      },
                                                      [
                                                        _c("input", {
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              !!message.active,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleToggleChange(
                                                                message,
                                                                $event
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._m(3, true),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-small is-white tooltip is-tooltip-bottom ml-1",
                                                    attrs: {
                                                      "data-tooltip": "Edit",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editMessage(
                                                          message
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._m(4, true)]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-small is-white tooltip is-tooltip-bottom ml-1",
                                                    attrs: {
                                                      "data-tooltip": "Delete",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmDelete(
                                                          message
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._m(5, true)]
                                                ),
                                                _vm.selectedTab === "archived"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button is-small is-white tooltip is-tooltip-bottom ml-1",
                                                        attrs: {
                                                          "data-tooltip":
                                                            "Restore",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.restoreMessage(
                                                              message
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._m(6, true)]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "message-content mb-2 is-size-7",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.truncateText(
                                                    message.caption,
                                                    150
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        message.startAtUtc || message.endAtUtc
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center is-size-7 has-text-grey",
                                              },
                                              [
                                                _vm._m(7, true),
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatDisplayDate(
                                                          message.startAtUtc
                                                        )
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        _vm.formatDisplayDate(
                                                          message.endAtUtc
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                _vm.isLoadingMore
                                  ? _c(
                                      "div",
                                      { staticClass: "has-text-centered p-4" },
                                      [
                                        _vm._m(8),
                                        _c("span", { staticClass: "ml-2" }, [
                                          _vm._v("Loading more..."),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.hasMoreMessages &&
                                _vm.filteredMessages.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-text-centered p-4 has-text-grey is-size-7",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v("— End of messages —"),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "cell is-col-span-6" }, [
                    _c(
                      "article",
                      {
                        staticClass:
                          "box detail-page-tile is-flex is-flex-direction-column",
                      },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.isEditing
                                ? "Edit Message"
                                : "Create New Message"
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "is-flex-grow-1" }, [
                          _c("div", { staticClass: "field" }, [
                            _vm._m(9),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerEntity.title,
                                    expression: "innerEntity.title",
                                  },
                                ],
                                staticClass: "input",
                                class: {
                                  "is-danger": _vm.$v.innerEntity.title.$error,
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: "Add message title",
                                },
                                domProps: { value: _vm.innerEntity.title },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.innerEntity,
                                      "title",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            !_vm.$v.innerEntity.title.required &&
                            _vm.$v.innerEntity.title.$dirty
                              ? _c("p", { staticClass: "help is-danger" }, [
                                  _vm._v("Message title is required"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _vm._m(10),
                            _c("div", { staticClass: "control" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerEntity.caption,
                                    expression: "innerEntity.caption",
                                  },
                                ],
                                staticClass: "textarea",
                                class: {
                                  "is-danger":
                                    _vm.$v.innerEntity.caption.$error,
                                },
                                attrs: {
                                  rows: "3",
                                  placeholder: "Brief message shown by default",
                                },
                                domProps: { value: _vm.innerEntity.caption },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.innerEntity,
                                      "caption",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            !_vm.$v.innerEntity.caption.required &&
                            _vm.$v.innerEntity.caption.$dirty
                              ? _c("p", { staticClass: "help is-danger" }, [
                                  _vm._v("Short message is required"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Detailed Message (optional)"),
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerEntity.message,
                                    expression: "innerEntity.message",
                                  },
                                ],
                                staticClass: "textarea",
                                attrs: {
                                  rows: "4",
                                  placeholder:
                                    "Additional details shown when the user clicks 'Read More'",
                                },
                                domProps: { value: _vm.innerEntity.message },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.innerEntity,
                                      "message",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _vm._m(11),
                            _c("div", { staticClass: "control" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "select is-fullwidth",
                                  class: {
                                    "is-danger": _vm.$v.innerEntity.type.$error,
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.innerEntity.type,
                                          expression: "innerEntity.type",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.innerEntity,
                                            "type",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select"),
                                      ]),
                                      _vm._l(_vm.messageTypes, function (type) {
                                        return _c(
                                          "option",
                                          {
                                            key: type.value,
                                            domProps: { value: type.value },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(type.label) + " "
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]),
                            !_vm.$v.innerEntity.type.required &&
                            _vm.$v.innerEntity.type.$dirty
                              ? _c("p", { staticClass: "help is-danger" }, [
                                  _vm._v("Message type is required"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _vm._m(12),
                            _c("div", { staticClass: "columns is-mobile" }, [
                              _c(
                                "div",
                                { staticClass: "column" },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      "is-dark": _vm.$theme.isDark,
                                      masks: _vm.dateFormats,
                                      attributes: _vm.dateAttrs,
                                      locale: _vm.$userInfo.locale,
                                      timezone: _vm.$filters.getIanaTimezone(),
                                      "minute-increment": 5,
                                      mode: "dateTime",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function ({
                                          inputValue,
                                          inputEvents,
                                        }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "control has-icons-left",
                                              },
                                              [
                                                _c(
                                                  "input",
                                                  _vm._g(
                                                    {
                                                      staticClass: "input",
                                                      class: {
                                                        "is-danger":
                                                          _vm.$v.innerEntity
                                                            .startAtUtc.$error,
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          "Start Date & Time",
                                                      },
                                                      domProps: {
                                                        value: inputValue,
                                                      },
                                                    },
                                                    inputEvents
                                                  )
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "icon is-small is-left",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "mdi mdi-calendar mdi-18px",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            !_vm.$v.innerEntity.startAtUtc
                                              .required &&
                                            _vm.$v.innerEntity.startAtUtc.$dirty
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "help is-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Start date & time is required"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.$v.innerEntity.startAtUtc
                                              .required &&
                                            _vm.$v.innerEntity.startAtUtc
                                              .$error &&
                                            !_vm.$v.innerEntity.startAtUtc
                                              .minDate
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "help is-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Start date must be today or later"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.innerEntity.startAtUtc,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.innerEntity,
                                          "startAtUtc",
                                          $$v
                                        )
                                      },
                                      expression: "innerEntity.startAtUtc",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "column" },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      "is-dark": _vm.$theme.isDark,
                                      masks: _vm.dateFormats,
                                      attributes: _vm.dateAttrs,
                                      locale: _vm.$userInfo.locale,
                                      timezone: _vm.$filters.getIanaTimezone(),
                                      "minute-increment": 5,
                                      mode: "dateTime",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function ({
                                          inputValue,
                                          inputEvents,
                                        }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "control has-icons-left",
                                              },
                                              [
                                                _c(
                                                  "input",
                                                  _vm._g(
                                                    {
                                                      staticClass: "input",
                                                      class: {
                                                        "is-danger":
                                                          _vm.$v.innerEntity
                                                            .endAtUtc.$error,
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          "End Date & Time",
                                                      },
                                                      domProps: {
                                                        value: inputValue,
                                                      },
                                                    },
                                                    inputEvents
                                                  )
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "icon is-small is-left",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "mdi mdi-calendar mdi-18px",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            !_vm.$v.innerEntity.endAtUtc
                                              .required &&
                                            _vm.$v.innerEntity.endAtUtc.$dirty
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "help is-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "End date & time is required"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.$v.innerEntity.endAtUtc
                                              .required &&
                                            _vm.$v.innerEntity.endAtUtc
                                              .$error &&
                                            !_vm.$v.innerEntity.endAtUtc
                                              .greaterThanStartDate
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "help is-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "End date must be after start date"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.innerEntity.endAtUtc,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.innerEntity,
                                          "endAtUtc",
                                          $$v
                                        )
                                      },
                                      expression: "innerEntity.endAtUtc",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c("hr", { staticClass: "my-4" }),
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Link Text"),
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerEntity.linkText,
                                    expression: "innerEntity.linkText",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  type: "text",
                                  placeholder: "Add text for link",
                                },
                                domProps: { value: _vm.innerEntity.linkText },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.innerEntity,
                                      "linkText",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Link URL"),
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerEntity.linkUrl,
                                    expression: "innerEntity.linkUrl",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  type: "text",
                                  placeholder: "Add link URL",
                                },
                                domProps: { value: _vm.innerEntity.linkUrl },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.innerEntity,
                                      "linkUrl",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-justify-content-flex-end pt-4",
                            staticStyle: {
                              "border-top": "1px solid var(--bulma-border)",
                            },
                          },
                          [
                            _vm.isEditing
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "button mr-2",
                                    on: { click: _vm.cancelEdit },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-18px mr-1" },
                                      [_vm._v(" close ")]
                                    ),
                                    _c("span", [_vm._v("Cancel")]),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass: "button mr-2",
                                on: { click: _vm.saveAsDraft },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "msr msr-18px mr-1" },
                                  [_vm._v(" edit ")]
                                ),
                                _c("span", [_vm._v("Save as Draft")]),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "button is-success",
                                on: { click: _vm.saveAndActivate },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "msr msr-18px mr-1" },
                                  [_vm._v(" save ")]
                                ),
                                _c("span", [_vm._v("Save & Activate")]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c(
                  "base-modal-ex",
                  {
                    attrs: {
                      active: _vm.isDeleteModalActive,
                      "animation-in": "zoomIn",
                      "animation-out": "zoomOut",
                      "animation-duration": 0.3,
                      "can-cancel": false,
                      "min-width": 40,
                      "has-modal-card": "",
                    },
                    on: {
                      "update:active": function ($event) {
                        _vm.isDeleteModalActive = $event
                      },
                    },
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v("Confirm Delete"),
                      ]),
                    ]),
                    _c("section", { staticClass: "modal-card-body" }, [
                      _c("p", [
                        _vm._v(
                          "Are you sure you want to delete this system message?"
                        ),
                      ]),
                      _c(
                        "p",
                        { staticClass: "has-text-weight-semibold mt-2" },
                        [_vm._v(_vm._s(_vm.messageToDelete?.title))]
                      ),
                    ]),
                    _c(
                      "footer",
                      {
                        staticClass:
                          "modal-card-foot is-flex is-justify-content-flex-end",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button mr-2",
                            on: {
                              click: function ($event) {
                                _vm.isDeleteModalActive = false
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "msr msr-18px mr-1" }, [
                              _vm._v(" close "),
                            ]),
                            _vm._v(" Cancel "),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button is-danger",
                            on: { click: _vm.deleteMessage },
                          },
                          [
                            _c("span", { staticClass: "msr msr-18px mr-1" }, [
                              _vm._v(" delete "),
                            ]),
                            _c("span", [_vm._v("Delete")]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-large" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-16px" }, [_vm._v("check_circle")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tag is-danger mr-2 has-text-light" }, [
      _c("span", { staticClass: "icon" }, [
        _c("span", { staticClass: "msr msr-16px" }, [
          _vm._v("do_not_disturb_on"),
        ]),
      ]),
      _vm._v("  Inactive "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [_c("label")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-restore mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small mr-1" }, [
      _c("i", { staticClass: "mdi mdi-clock-outline mdi-14px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "label" }, [
      _vm._v("Message Title "),
      _c("span", { staticClass: "has-text-danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "label" }, [
      _vm._v("Short Message "),
      _c("span", { staticClass: "has-text-danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "label" }, [
      _vm._v("Message Type "),
      _c("span", { staticClass: "has-text-danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "label" }, [
      _vm._v("Display Duration "),
      _c("span", { staticClass: "has-text-danger" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }